<template>
  <div>
    <v-card elevation="12" class="mx-6 my-6 pa-0" link>
      <v-card-text class="pa-0">
        <vue-dropzone ref="dropzone" id="dropzone" class="dropzone" :options="dropzoneOptions" :useCustomSlot="true" duplicateCheck includeStyling @vdropzone-files-added="filesAdded">
          <div class="dropzone-custom-content">
            <h3 class="dropzone-custom-title">{{headText}}</h3>
            <div class="subtitle">{{$t('general.clickToSearchOnTheComputer')}}</div>
          </div>
        </vue-dropzone>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import vueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default {
  components: {
    vueDropzone
  },
  data () {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        maxFilesize: 20, // MB,
        maxFiles: this.maxFiles,
        acceptedFiles: this.acceptedFiles,
        uploadMultiple: this.uploadMultiple,
        autoProcessQueue: false, // Disable autoupload
        clickable: true, // by default is true
        disablePreview: true, // Not working
        hiddenInputContainer: this.hiddenInputContainer
      }
    }
  },
  methods: {
    filesAdded () { // files) {
      // console.log('files')
      // console.log(files)
      // Wait a second because files are not enqueed yet
      setTimeout(() => {
        // TODO: duplicateCheck is not working
        this.$emit('filesAdded', this.$refs.dropzone.getQueuedFiles())
      }, 500)
    },
    removeAllFiles () {
      // apparently this is not working. but input dom was hidden with display:none property
      this.$refs.dropzone.removeAllFiles()
    }
  },
  props: {
    acceptedFiles: {
      type: String
    },
    hiddenInputContainer: { // dom el to append input type="file", required
      type: HTMLDivElement,
      required: true
    },
    headText: {
      type: String,
      default: 'Arrastra y suelta archivos en esta zona'
    },
    uploadMultiple: {
      type: Boolean,
      default: true
    },
    maxFiles: {
      type: Number,
      default: null
    }
  }
}
</script>

<style scoped>
/* @import url("https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css");

#dropzone >>> .dz-message {
  font-weight: 700;
}

#dropzone >>> .fa-cloud-upload {
  margin-right: 10px;
}

.dropzone {
  position: relative;
  height: 100px;
  cursor: pointer;
}

.dropzone-custom-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.dropzone-custom-title {
  margin-top: 0;
}

.subtitle {
  color: #acacac;
}

.dz-default {
  display: none
}

#dropzone >>> .dz-file-preview {
  display: none;
} */
</style>
